<style lang="stylus" scope>
    .sharebox
        width 100%
        height 178px
        background #fff
        box-shadow 0px 0px 4px #C1C6CC
        border-radius 2px
        cursor default
        .sharebox-topbar
            display flex
            justify-content space-between
            align-items center
            height 28px
            padding 0 5px 0 15px
            border-bottom 1px solid #E7E7E7
            p
                font-size 12px
                color #000
            .sharebox-close
                display flex
                width 18px
                height 18px
                padding 5px
                user-select none
                cursor pointer
                svg
                    width 8px
                    height 8px
                    color #757575
        .sharebox-content
            padding 15px
            .sharebox-linkbox
                display flex
            .sharebox-sharetype
                display flex
                align-items flex-end
                justify-content space-between
                ul
                    display flex
                    align-items flex-end
                    width 280px
                    height 90px
                    li
                        width 20px
                        height 20px
                        border-radius 50%
                        margin-right 10px
                        user-select none
                        cursor pointer
                        svg
                            width 20px
                            height 20px
                .sharebox-qrcode
                    width 80px
                    height 80px
                    img
                        width 100%
                        height 100%
</style>

<template>
    <div class="sharebox">
        <div class="sharebox-topbar">
            <p>分享个人主页</p>
            <div class="sharebox-close" @click="closeShareBox()">
                <iconSymbol name="close" />
            </div>
        </div>
        <div class="sharebox-content">
            <div class="sharebox-linkbox">
                <Input ref="shareInput" size="small" v-model="shareLink"></Input>
                <Button size="small" plain style="margin-left: 10px" @click="copyLink">复制链接</Button>
            </div>

            <div class="sharebox-sharetype">
                <ul>
                    <li v-for="item in iconList" :key="item.id" @click="selectShareType(item.id)">
                        <iconSymbol :name="item.name" />
                    </li>
                </ul>
                <div class="sharebox-qrcode" v-show="showQR">
                    <img ref="shareQrcode" src="" alt="" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { addJs } from "@/public/utils/tool";
    import appConfig from "@/public/globalConfig";

    export default {
        name: "sharebox",
        data() {
            return {
                iconList: [
                    {
                        id: 0,
                        name: "wechat",
                    },
                    {
                        id: 1,
                        name: "sina",
                    },
                    {
                        id: 2,
                        name: "qq",
                    },
                    {
                        id: 3,
                        name: "qzone",
                    },
                ],
                showQR: false,
                qrTimer: 0,
                shareLink: "",
                shareTitle: "",
            };
        },
        components: {},
        props: {},
        methods: {
            selectShareType(id) {
                let url = "";
                this.showQR = false;
                let open = (url) => {
                    let newTab = window.open("about:blank");
                    newTab.location.href = url;
                };
                switch (id) {
                    case 0: // wx
                        if (this.qrTimer) {
                            clearTimeout(this.qrTimer);
                        }
                        this.qrTimer = setTimeout(() => {
                            this.showQRCode();
                        }, 300);
                        break;
                    case 1: // wb
                        url = `http://service.weibo.com/share/share.php?url=${this.shareLink}&type=button&style=number&appkey=3113778129&title=${this.shareTitle}&pic=&ralateUid=6009693789&language=zh_cn`;
                        open(url);
                        break;
                    case 2: // qq
                        url = `https://connect.qq.com/widget/shareqq/index.html?url=${this.shareLink}&title=${this.shareTitle}&desc=&pics=&summary=Powered by EdrawMax`;
                        open(url);
                        break;
                    case 3: // qzone
                        url = `https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=${this.shareLink}&title=${this.shareTitle}`;
                        open(url);
                        break;
                    default:
                        break;
                }
            },
            showQRCode() {
                this.showQR = false;
                let callback = () => {
                    qrcode.stringToBytes = qrcode.stringToBytesFuncs["UTF-8"];
                    let qr = qrcode(0, "H");
                    qr.addData(this.shareLink, "Byte");
                    qr.make();

                    this.$refs.shareQrcode.src = "data:image/svg+xml;utf8," + qr.createSvgTag(2, 0);
                    this.showQR = true;
                };
                addJs(appConfig.sourcePath + "/js/3rd/qrcode.min.js", callback);
            },
            copyLink() {
                let success;
                this.$refs.shareInput.$el.children[0].select();
                success = document.execCommand("copy");

                if (success) {
                    this.$edMessage.success("复制成功！");
                }
            },
            closeShareBox() {
                this.$emit("close");
            },
        },
        mounted() {
            this.shareLink = location.href;
        },
    };
</script>
